import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface RestoreAssetPayload {
  uuid: string;
}

export const useRestoreAsset = (
  options?: UseMutationOptions<any, Error, RestoreAssetPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["restoreAsset"],
    mutationFn: async ({ uuid }: RestoreAssetPayload) => {
      return axiosInstance
        .post(`/investments/${uuid}/restore`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Przywracanie aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "restore-asset",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Aktywo zostało przywrócone.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "restore-asset",
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas przywracania aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "restore-asset",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
